import { useQuery } from "@tanstack/react-query";
import { useChosenDepartment } from "../../../../contexts/ChosenDepartment";
import { backendService } from "../../../../services/backend.service";
import type { RoleJobRecommendation } from "../../../../utils/models";

export const JOB_RECOMMENDATIONS_QUERY_KEY = "job-recommendations";

/**
 * DAT-586: per-role job combinations the chosen department's facility already staffs, used to
 * suggest jobs above the employee form's job picker. Informational only — never auto-selects.
 *
 * Every role comes back in one response, keyed only by department, so switching the role dropdown
 * is a client-side lookup rather than a refetch. The underlying aggregate is a facility-wide count
 * over existing employees and can't meaningfully change while the form is open, hence the stale time.
 */
export function useJobRecommendations(options?: { enabled?: boolean }) {
	const { chosenDepartment } = useChosenDepartment();
	const departmentId = chosenDepartment.department_id;

	return useQuery<RoleJobRecommendation[]>({
		queryKey: [JOB_RECOMMENDATIONS_QUERY_KEY, departmentId],
		queryFn: async () => {
			const res = await backendService.getJobRecommendations(departmentId);
			return res.data;
		},
		enabled: options?.enabled !== false && !!departmentId,
		staleTime: 5 * 60 * 1000,
	});
}
